import { EntityName } from 'record-it-time-common/EntityName';
import { TimeTrackingActivityCompilation } from '../../../classes/entities/TimeTrackingActivityCompilation/timeTrackingActivityCompilationTypes';
import { useEntityDeleteHandler } from './useEntityDeleteHandler';

export function useTimeTrackingActivityCompilationDeleteHandler(
  timeTrackingActivityCompilation: TimeTrackingActivityCompilation
): () => void {
  return useEntityDeleteHandler(
    EntityName.TimeTrackingActivityCompilation,
    timeTrackingActivityCompilation,
    (compilation) => compilation.name
  );
}
